import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { GlobalSearchService } from './globalsearchservice.service';

@Injectable({ providedIn: 'root' })
export class BrandStorefrontService {
	config: any;
	user: any = { user: {} };
	httpOptions = {
		headers: new HttpHeaders({ 'Content-Type': 'application/json' })
	};

	constructor(private http: HttpClient, private globalSearchService: GlobalSearchService) {
		this.globalSearchService.configsubscription.subscribe(r => { this.config = r; });
		this.globalSearchService.user.subscribe((r: any) => { this.user = r || { user: {} }; });
	}

	list() {
		return this.http.get(this.setEndPoint('brandstorefront/list')).pipe(catchError(this.handleError('list')));
	}

	getConfig(manufacturerId: number) {
		return this.http.get(this.setEndPoint('brandstorefront/config&manufacturer_id=' + manufacturerId)).pipe(catchError(this.handleError('config')));
	}

	saveConfig(data: any) {
		return this.http.post(this.setEndPoint('brandstorefront/saveconfig'), data, this.httpOptions).pipe(catchError(this.handleError('saveconfig')));
	}

	saveSubscription(data: any) {
		return this.http.post(this.setEndPoint('brandstorefront/subscription'), data, this.httpOptions).pipe(catchError(this.handleError('subscription')));
	}

	/** Persist brand-wall order. Sends ids in display order; the server writes
	 *  sort_order from the array position. */
	reorder(manufacturerIds: number[]) {
		return this.http.post(this.setEndPoint('brandstorefront/reorder'), { order: manufacturerIds }, this.httpOptions)
			.pipe(catchError(this.handleError('reorder')));
	}

	runBilling(asOf?: string) {
		return this.http.post(this.setEndPoint('brandstorefront/runbilling'), { as_of: asOf || '' }, this.httpOptions).pipe(catchError(this.handleError('runbilling')));
	}

	private setEndPoint(method: string) {
		return this.getApi() + method + this.getApiKey();
	}

	private getApi() {
		return this.config?.apiServer?.endpoint || '';
	}

	private getApiKey() {
		const uid = this.user?.user?.userid || '';
		const key = this.config?.apiCredentials?.clientId || '';
		return '&key=' + key + '&userid=' + uid;
	}

	private handleError(op: string) {
		return (error: any) => throwError(() => error);
	}
}
